import { render, staticRenderFns } from "./kiosk-password.vue?vue&type=template&id=4ee0bd6d&"
import script from "./kiosk-password.vue?vue&type=script&lang=js&"
export * from "./kiosk-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports